const schools = [
  {
    name: "ATC Language Schools Dublin",
    location: "ダブリン2区",
    features: ["1991年創立の老舗校", "少人数クラス制", "認定校・高品質な授業"],
    level: "初級〜上級",
    img: "https://storage.readdy-site.link/project_files/4c258df0-4795-43d0-92fa-ad229c3fae38/668180b5-7c09-4c16-99aa-22d7c68f5f96_ATC_Dublin_Adult_English_Students_Celebrating.jpg?v=4153d3e095fb2a90da45625d16e5e79e",
    tag: "人気No.1",
    tagColor: "bg-emerald-500",
    imgPosition: "top",
  },
  {
    name: "EC English Dublin",
    location: "ダブリン2区",
    features: ["最新設備の校舎", "オンライン学習も充実", "週25〜30レッスン"],
    level: "初級〜上級",
    img: "https://storage.readdy-site.link/project_files/4c258df0-4795-43d0-92fa-ad229c3fae38/829e4c99-b918-48cb-b647-282e490e23e4_EC-Dublin-students-with-Ireland-flag.jpg?v=9e443ff9da8a97d4be6cf1bd9e3f4274",
    tag: "施設充実",
    tagColor: "bg-sky-500",
    imgPosition: "center",
  },
  {
    name: "ATLAS Language School",
    location: "ダブリン2区",
    features: ["アイルランド人学生と交流", "ホームステイ紹介あり", "IELTS対策コース"],
    level: "初級〜上級",
    img: "https://storage.readdy-site.link/project_files/4c258df0-4795-43d0-92fa-ad229c3fae38/b3e0a7e7-38f7-4a3d-b630-605d86eb47be_Hellfire-Club-Walk.jpeg?v=20b43679b8970b892a98c55db6307dbe",
    tag: "地元密着",
    tagColor: "bg-amber-500",
    imgPosition: "0% 5%",
  },
  {
    name: "Centre of English Studies (CES)",
    location: "ダブリン・シティセンター",
    features: ["1979年創立の老舗校", "充実したアクティビティ", "世界各国の生徒が集まる"],
    level: "初級〜上級",
    img: "https://storage.readdy-site.link/project_files/4c258df0-4795-43d0-92fa-ad229c3fae38/e7cff374-2205-447b-a745-92bad574c2e3_CES-Dublin---reception-area.jpg?v=9ef40d0568da94fb04c9fa7d8c2ec062",
    tag: "老舗実績",
    tagColor: "bg-rose-500",
    imgPosition: "center",
  },
];

export default function SchoolsSection() {
  return (
    <section id="schools" className="py-20" style={{ background: "linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)" }}>
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="text-emerald-600 text-sm font-semibold tracking-widest uppercase">Schools</span>
          <h2 className="text-3xl font-bold text-gray-800 mt-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            🏫 語学学校のご紹介
          </h2>
          <p className="text-gray-500 mt-3 text-sm max-w-xl mx-auto">
            ClassLive留学がおすすめするアイルランドの語学学校を一部ご紹介します。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-7">
          {schools.map((s, i) => (
            <div key={i} className="bg-white rounded-lg overflow-hidden border border-gray-100 hover:border-emerald-200 transition-all group">
              <div className="relative w-full h-44">
                <img
                  src={s.img}
                  alt={s.name}
                  className="w-full h-full object-cover"
                  style={{ objectPosition: s.imgPosition }}
                />
                <span className={`absolute top-3 left-3 ${s.tagColor} text-white text-xs font-bold px-2.5 py-1 rounded-full`}>
                  {s.tag}
                </span>
              </div>
              <div className="p-5">
                <div className="flex items-start justify-between mb-2">
                  <h3 className="font-bold text-gray-800 text-sm leading-snug flex-1">{s.name}</h3>
                </div>
                <div className="flex items-center gap-1.5 text-xs text-gray-500 mb-3">
                  <span className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-map-pin-line" /></span>
                  {s.location}
                  <span className="ml-2 bg-gray-100 px-2 py-0.5 rounded text-gray-600">{s.level}</span>
                </div>
                <div className="flex flex-wrap gap-1.5">
                  {s.features.map((f, j) => (
                    <span key={j} className="bg-emerald-50 text-emerald-700 text-xs px-2.5 py-1 rounded-full border border-emerald-100">
                      {f}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-sm text-gray-500 mt-8">
          ＊ 上記以外にも多数の提携校がございます。詳しくはお気軽にご相談ください。
        </p>
      </div>
    </section>
  );
}
